import { useMemo } from 'react';
import { CategoryType } from '../../../services/exports/Constants';
import useMenu from '../../../hooks/menu/useMenu';
import collect from 'collect.js';
import CustomCarousel, { Item } from '../CustomCarousel';
import useScreenType from '../../../hooks/utility/useScreenType';
import { CategoryInterface, ProductInterface } from '../../../services/exports/Interfaces';
import { WithActualPrice } from '../../../providers/MenuProvider';
import MostPopularProduct from './MostPopularProduct';
import classNames from 'classnames';

interface Props {
  className?: string;
  toggleProduct: (product: ProductInterface) => void;
}

const MostPopularProductsCarousel = (props: Props) => {
  const { toggleProduct, className } = props;
  const { allCategories } = useMenu();
  const { isDesktop } = useScreenType();

  const mostPopularCategory = useMemo<CategoryInterface<WithActualPrice<ProductInterface>>>(
    () => collect(allCategories).where('type', CategoryType.MostPopular).first(),
    [allCategories],
  );

  const items = useMemo<Item[]>(() => {
    if (!mostPopularCategory) return [];

    return collect(mostPopularCategory.products)
      .where('is_available', true)
      .unique('id')
      .map((product, index) => {
        return {
          data: product,
          render: () => <MostPopularProduct product={product} index={index} toggleProduct={toggleProduct} />,
        };
      })
      .toArray();
  }, [mostPopularCategory]);

  if (!mostPopularCategory) return null;

  return (
    <div className={classNames('relative w-full', className)} id={`category-id-${mostPopularCategory.id}`}>
      <CustomCarousel
        items={items}
        itemsPerSlide={isDesktop ? 5 : 2.1}
        slideJump={isDesktop ? 3 : 2}
        autoHeight
        gap={isDesktop ? 16 : 8}
        arrowsPosition="top"
        hideArrows={false}
        arrowsClassName="lg:mr-lg mr-md"
        itemsClassName="lg:pl-none pl-md"
        title={<h5 className="lg:ml-none ml-md">{mostPopularCategory.name}</h5>}
        headerClassName="mb-[6px]"
      />
    </div>
  );
};

export default MostPopularProductsCarousel;
